/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { Category, GuideProgramList } from 'client-code/filtered-guide';

import { FilteredGuideRepositoryImpl } from '../impls';
import { IFilteredGuideService, IFilteredGuideServiceRepository } from '../interfaces';
import { TiVoNetworkRequestModel } from '../tivo';
import { TServicesParams } from '../types';

export class FilteredGuideService implements IFilteredGuideService {
    private static TAG: string = 'FilteredGuideService';

    private readonly mFilteredGuideServiceRepository: IFilteredGuideServiceRepository;

    public constructor(params: TServicesParams) {
        this.mFilteredGuideServiceRepository = new FilteredGuideRepositoryImpl(params);
    }

    /**
     * Retrieves a filtered list of programs based on specified criteria
     * @param category - The category to filter programs by
     * @param startTime - The start time of the time window to fetch programs for
     * @param endTime - The end time of the time window to fetch programs for
     * @param channelFilter - Optional filter for favorite or subscribed channels
     * @param offset - The number of items to skip before starting to collect results (default: 0)
     * @param count - The maximum number of items to return (default: 1000)
     * @returns Promise containing an array of FilteredGuideRow objects
     */
    public fetchFilteredPrograms(
        category: Category,
        startTime: Date,
        channelFilter?: 'favorites' | 'subscribed' | undefined,
        offset: number = 0,
        count: number = 1000,
    ): TiVoNetworkRequestModel<GuideProgramList> {
        const oRequestModel = new TiVoNetworkRequestModel<GuideProgramList>(
            this.mFilteredGuideServiceRepository.fetchFilteredPrograms.bind(
                this.mFilteredGuideServiceRepository,
            ),
        );
        oRequestModel.addRequestParams(category, startTime, channelFilter, offset, count);
        return oRequestModel;
    }
}
